<div class="flex-grid">
  <ng-container *ngIf="!row.loading; else loading">
    <ng-container *ngIf="!isReorderingRow; else reorderGrid">
      <ul class="grid">
        <li *ngIf="showAddTile" [ngClass]="row.gridClass">
          <dgx-add-tile
            [label]="row.addTileName | translate"
            (clickTile)="onAddResource()"
            data-dgat="gridSection-f7c"
          >
          </dgx-add-tile>
        </li>

        <li
          *ngFor="
            let item of rowResources;
            trackBy: resourceTrackBy;
            let i = index
          "
          dgxIntersectionObserver
          (onIntersection)="onIntersectionOfResource(item, i)"
          [ngClass]="row.gridClass"
          data-dgat="flexRow-639"
        >
          <ng-container
            *ngTemplateOutlet="gridItem; context: { $implicit: item }"
          ></ng-container>
        </li>
        <ng-container *ngIf="isEditing && !isReorderingRow">
          <li
            *ngFor="let stub of row.stubCount"
            [ngClass]="row.gridClass"
            data-dgat="flexRow-1f5"
          >
            <div class="tile tile--stub"></div>
          </li>
        </ng-container>
      </ul>
    </ng-container>
  </ng-container>
</div>

<ng-template #loading>
  <ul class="grid">
    <li
      [ngClass]="row.gridClass"
      *ngFor="let skeleton of row.skeletonCount"
      data-dgat="flexRow-660"
    >
      <div class="tile__wrapper">
        <dgx-skeleton [type]="typeForSkeleton"></dgx-skeleton>
      </div>
    </li>
  </ul>
</ng-template>

<ng-template #reorderGrid>
  <ul
    *ngIf="!row.loading"
    class="grid"
    dgxSortableList
    [sortingDisabled]="!isReorderingRow"
    [sort]="onSort"
    [tileHeight]="289"
  >
    <li
      *ngFor="
        let item of this.row.targetResources;
        trackBy: resourceTrackBy;
        let i = index
      "
      [ngClass]="row.gridClass"
      data-dgat="flexRow-639"
      dgxSortable
      [sortableItem]="item"
      [sortableIndex]="i"
    >
      <ng-container
        *ngTemplateOutlet="gridItem; context: { $implicit: item }"
      ></ng-container>
    </li>
    <ng-container *ngIf="isEditing && !isReorderingRow">
      <li
        *ngFor="let stub of row.stubCount"
        [ngClass]="row.gridClass"
        data-dgat="flexRow-1f5"
      >
        <div class="tile tile--stub"></div>
      </li>
    </ng-container>
  </ul>
</ng-template>

<ng-template #gridItem let-item>
  <ng-container [ngSwitch]="getTileType(item)">
    <ng-container *ngSwitchCase="'Tag'">
      <dgx-tag-tile
        class="block"
        [tag]="item.reference"
        [(targetLevel)]="item.parameter"
        (removeFromPlan)="onRemoveResourceFromRow(row, item)"
        [actionsContext]="row"
        [isOwner]="!isEditing"
        [targetAuthoring]="isEditing"
        [hideFollowing]="isEditing"
        [targetId]="row.section.targetId"
        [showAddTarget]="isEditing && !item.parameter"
        trackingLocation="Plan"
        data-dgprop-location="Plan"
      ></dgx-tag-tile>
    </ng-container>

    <ng-container *ngSwitchCase="'Provider'">
      <dgx-flex-provider-card
        [provider]="item.reference"
        [isEditing]="isEditing"
        [addMenuFn]="providerBubbleMenuConfigFn(row)"
      ></dgx-flex-provider-card>
    </ng-container>

    <ng-container *ngSwitchCase="'Group'">
      <dgx-group-tile
        [group]="item.reference"
        [modifyOptionsFn]="row.modifyMenuOptionsFn"
        data-dgat="flexRow-684"
      ></dgx-group-tile>
    </ng-container>

    <dgx-skill-standards-segment-card
      *ngSwitchCase="'SkillStandardsSegment'"
      class="segment-card"
      [segment]="item"
      [modifyOptionsFn]="row.modifyMenuOptionsFn"
    ></dgx-skill-standards-segment-card>

    <dgx-opportunity-card
      *ngSwitchCase="'Opportunity'"
      [opportunity]="item.reference"
      class="full-height"
    ></dgx-opportunity-card>

    <!-- The rest: Target | Pathway | Directory | UserContent | User | Any-->
    <dgx-tile-launcher
      *ngSwitchDefault
      [item]="item.reference"
      [actionContext]="row"
      [modifyOptionsFn]="row.modifyMenuOptionsFn"
    >
    </dgx-tile-launcher>
  </ng-container>
</ng-template>
